import React from 'react';
import { useClientId } from '../../hooks/useClientId';
import { GenerateClientIdButton } from './GenerateClientIdButton';
import { ManageClientIdButton } from './ManageClientIdButton';
export default function ClientIdButton() {
    const { isGenerateButtonVisible } = useClientId();
    return (React.createElement(React.Fragment, null, isGenerateButtonVisible ? React.createElement(GenerateClientIdButton, null) : React.createElement(ManageClientIdButton, null)));
}
